import ProjectClaimsSidebarWidgetComponent from './sidebar-widget.component'
import ClaimTimerComponent from '../claim-timer/claim-timer.component'

const ProjectClaimsSidebarWidgetModule = angular.module('cdbl.sidebar-claim-widget', [

])
  .component('cdblProjectClaimsSidebarWidget', ProjectClaimsSidebarWidgetComponent)
  .component('cdblClaimTimer', ClaimTimerComponent)
  .name

export default ProjectClaimsSidebarWidgetModule
